// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__36taG","amount":"Amount_amount__1yXnG","tip":"Amount_tip__3nMHs","tipHeader":"Amount_tipHeader__3Fbbk","tipsWrap":"Amount_tipsWrap__1AoJk"};